/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardDoughnutUseCase } from './DashboardDoughnutUseCase';
import {
  DashboardDoughnutUseCaseFromJSON,
  DashboardDoughnutUseCaseFromJSONTyped,
  DashboardDoughnutUseCaseToJSON,
} from './DashboardDoughnutUseCase';

/**
 *
 * @export
 * @interface DashboardDoughnutUseCases
 */
export interface DashboardDoughnutUseCases {
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutUseCases
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutUseCases
   */
  maxCount: number;
  /**
   *
   * @type {number}
   * @memberof DashboardDoughnutUseCases
   */
  restValue: number | null;
  /**
   *
   * @type {Array<DashboardDoughnutUseCase>}
   * @memberof DashboardDoughnutUseCases
   */
  results: Array<DashboardDoughnutUseCase>;
}

/**
 * Check if a given object implements the DashboardDoughnutUseCases interface.
 */
export function instanceOfDashboardDoughnutUseCases(value: object): value is DashboardDoughnutUseCases {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('maxCount' in value) || value['maxCount'] === undefined) return false;
  if (!('restValue' in value) || value['restValue'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function DashboardDoughnutUseCasesFromJSON(json: any): DashboardDoughnutUseCases {
  return DashboardDoughnutUseCasesFromJSONTyped(json, false);
}

export function DashboardDoughnutUseCasesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardDoughnutUseCases {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    maxCount: json['max_count'],
    restValue: json['rest_value'],
    results: (json['results'] as Array<any>).map(DashboardDoughnutUseCaseFromJSON),
  };
}

export function DashboardDoughnutUseCasesToJSON(value?: DashboardDoughnutUseCases | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    max_count: value['maxCount'],
    rest_value: value['restValue'],
    results: (value['results'] as Array<any>).map(DashboardDoughnutUseCaseToJSON),
  };
}
